import { BlocksIconShipping } from 'blocks-nextjs/blocks-web-components/components/icon/icons/shipping';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconShipping = createComponent({
  react: React,
  tagName: 'cat-icon-shipping',
  elementClass: BlocksIconShipping
});
